import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthShell from "../components/AuthShell";
import api, { formatApiError } from "../lib/api";

const input = "w-full border border-linen bg-white px-4 py-3 text-sm outline-none focus:border-pitch transition-colors";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch { setSent(true); } finally { setLoading(false); }
  };
  return (
    <AuthShell title="Reset Password" subtitle="Account recovery"
      footer={<Link to="/login" className="text-pitch border-b border-pitch pb-0.5">Back to Sign In</Link>}>
      {sent ? (
        <div className="bg-emeraldauth/10 border border-emeraldauth/30 text-charcoal text-sm px-4 py-4" data-testid="forgot-sent">
          If an account exists for {email}, a reset link has been sent. Please check your inbox.
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <p className="text-sm text-charcoal/70">Enter your email and we'll send you a link to reset your password.</p>
          <input required type="email" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} className={input} data-testid="forgot-email" />
          <button type="submit" disabled={loading} data-testid="forgot-submit"
            className="w-full bg-pitch text-ivory text-xs font-mono uppercase tracking-[0.2em] py-4 hover:bg-charcoal transition-colors disabled:opacity-50">
            {loading ? "Sending…" : "Send Reset Link"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
